module.exports = __webpack_public_path__ + "static/media/bgCustoms.6fe5e329.jpg";